<template>
  <default-text-input
    :value="socialIdNumber"
    type="tel"
    label="מספר ת.ז. (9 ספרות)"
    :autofocus="autofocus"
    :tabindex="tabindex"
    validations="required|socialId"
    v-on="$listeners">
    <template v-slot:append>
      <q-icon name="badge" />
    </template>
  </default-text-input>
</template>

<script>
import DefaultTextInput from '@/components/styled/DefaultTextInput';

export default {
  name: 'SocialIdNumberInput',
  components: { DefaultTextInput },
  props: {
    socialIdNumber: String,
    autofocus: Boolean,
    tabindex: {
      type: Number,
      default: 0,
    },
  },
};
</script>
